import { render, staticRenderFns } from "./media_holding_no_holdings.vue?vue&type=template&id=6e90512e&scoped=true"
import script from "./media_holding_no_holdings.vue?vue&type=script&lang=js"
export * from "./media_holding_no_holdings.vue?vue&type=script&lang=js"
import style0 from "./media_holding_no_holdings.vue?vue&type=style&index=0&id=6e90512e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e90512e",
  null
  
)

export default component.exports